import { forwardRef, type Ref, type SVGProps } from "react";

function SvgPhoneCircleWithDiamond(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={62} height={51} fill="none" {...props}>
      <path
        stroke="#0C1C43"
        strokeLinecap="round"
        d="m35.371 21.97-.707-3.186a1 1 0 0 0-.977-.784h-3.714c-.547 0-.996.44-.972.986.118 2.691.883 5.34 2.236 7.674a16.84 16.84 0 0 0 6.108 6.111c2.35 1.365 4.963 2.086 7.654 2.228.552.029 1.001-.422 1.001-.976V30.32a1 1 0 0 0-.784-.977l-3.183-.708a1 1 0 0 0-.926.27l-.844.845a.954.954 0 0 1-1.147.171 13.5 13.5 0 0 1-5.03-5.033.956.956 0 0 1 .17-1.148l.846-.845c.242-.242.344-.591.27-.925Z"
      />
      <path
        fill="#0C1C43"
        d="M.38 3.538 6.647.09a.73.73 0 0 1 .706 0l6.267 3.447a.733.733 0 0 1 .25 1.058l-6.267 9.087a.732.732 0 0 1-1.206 0L.13 4.597a.733.733 0 0 1 .25-1.06Z"
      />
      <circle
        cx={37}
        cy={26}
        r={22.5}
        stroke="url(#PhoneCircleWithDiamond_svg__a)"
        strokeWidth={5}
      />
      <defs>
        <linearGradient
          id="PhoneCircleWithDiamond_svg__a"
          x1={37}
          x2={37}
          y1={1}
          y2={51}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPhoneCircleWithDiamond);
export default ForwardRef;
